<template>
	<div class="page-wrapper">
        <div class="mx-auto">
			
			<div id="map"></div>

			<div class='selectCheck absolute fl my24 mx24 py24 px24 bg-gray-faint round' ref="htmlPopup" id="temp11">
				<form id='params'>
					<h6 class='txt-m txt-bold mb6' style="float:left;">Select Commute Time:</h6>
					<h6 @click="deletePin" style="float:right;"><v-icon name="trash" style="color: #6c6c70; cursor: pointer;" title="Delete"></v-icon></h6>
					<div>
						<b-form-select 
						name="duration" 
						v-model="selecteCommuteTime" 
						:options="optionsCommuteTime"
						@change="dropdownChangeEvent(selecteCommuteTime)"
						>
						</b-form-select>
					</div>
				</form>
			
			</div>

			<div style="text-align:center;">
				<button :disabled="disabledSaveMap" class="savempbtn AddnewMarkerBtn1" @click="SaveTilesetProcess()" style="margin-left:10px;">Save Map</button>
			</div>
			
		</div>

		<div v-if="loaderIf" class="col-sm-12 text-center loader-blue" 
		style="position: absolute;padding-left: 0;text-align: left !important; left: 150px;">
			<div class="loader4"></div>
		</div>
		
		<button class="AddnewMarkerBtn" @click="AddNewMarkerProcess()"><v-icon name="plus"></v-icon> Add Marker</button>

		<button class="AddnewMarkerBtn" style="margin-top:-90px;" @click="AddOfficeMarkerProcess()"><v-icon name="plus"></v-icon> Add Office Locations</button>

		<!-- <button class="AddnewMarkerBtn1" @click="SaveTilesetProcess()" style="margin-left:10px;">Save Map</button> -->

		<!-- <button class="AddnewMarkerBtn1" @click="firebaseFileCheck()" style="margin-left:10px;">Firebase File</button> -->

		<div class="savedStatus">
			<b-alert show dismissible variant="info" v-if="datasetStatus" @dismissed="datasetStatus=false">Map Successfully Saved.</b-alert>
			<!-- <b-alert show dismissible variant="info" v-if="tilesetStatusPublishing" @dismissed="tilesetStatusPublishing=false">Tileset is {{handlePublishStatus}}</b-alert> -->
			<b-alert show dismissible variant="info" v-if="tilesetStatusPublishing" @dismissed="tilesetStatusPublishing=false">{{customPrintMsg}}</b-alert>
			<b-alert show dismissible v-if="tilesetStatusPublished" @dismissed="tilesetStatusPublished=false">Tileset is Successfully Published.</b-alert>
		</div>

		<div class="w-90 mx-auto">
			<div class="fieldManage">
				<b-form>
					<b-form-group label-cols="4" label="Out of Area Automated Message:" class="col-sm-8">
						<b-form-textarea
							v-model="form.areaAutomatedText"
							@keyup="automatedTextUpdate"
						/>
					</b-form-group>
				</b-form>
			</div>
		</div>


    </div>
</template>

<script>
	import { mapState } from 'vuex'
	import Mapbox from "mapbox-gl";
    import axios from "axios";
	import { db, fbstore } from 'src/db'
	export default {
		name: "OutOfArea",
		created() {
			this.checkPrimaryLocation();
			setTimeout(() => {
				this.loadMap();	
			}, 3000);
			this.rechecktheTilesetStatus();
			//eslint-disable-next-line
			console.log('this.user.TilesetID', this.user.TilesetID);
		},	
		components: {

		},
		computed: {
			...mapState('firebase', ['prospects', 'user'])
		},
		methods: {
			// ADD OFFICES ON LOAD IF THERE DATASETS AND TILESETS ARE NOT AVAILABLE IN DATABASE
			addOfficesIfTilesetOrDatasetNotThere() {
				if(this.user.hasOwnProperty('TilesetID1') && this.user.hasOwnProperty('DataesetID1')) {
					//eslint-disable-next-line
					console.log(`TilesetID: ${this.user.TilesetID} and DatasetID: ${this.user.DataesetID} both are available.`);
				} else {
					setTimeout(() => {
						this.AddOfficeMarkerProcess();
					}, 3000);
				}
			},
			// ADD NEW MARKER BASED ON OFFICES ZIP CODE
			async AddOfficeMarkerProcess() {
				let storeOfficesZip = [];
                this.user.Offices.forEach(ofZip=>{
					if(ofZip.ZipCode) {
                        var a = storeOfficesZip.includes(ofZip.ZipCode);
						if(!a) { storeOfficesZip.push(ofZip.ZipCode); }
					}
				})
				for(var so of storeOfficesZip) {
                    await axios.get("https://app.zipcodebase.com/api/v1/search?apikey=cdbfa120-2941-11ef-825e-45214465aa92&codes="+so+"&country=us")
                    .then(response =>{
						if(response.data.results && response.data.results.hasOwnProperty([so])) {
							if(response.data.results[so][0].latitude && response.data.results[so][0].longitude){
							this.markerProcessWithOffice(response.data.results[so][0].latitude, response.data.results[so][0].longitude);
							}
						}
                    });
                }
            },
			async markerProcessWithOffice(lat, lng) {
				if(lat && lng){
				const marker1 = new this.mapbox.Marker({
					anchor: "center", 
					color: "#314ccd", 
					draggable: true
				})
				.setLngLat([lng, lat])
				.addTo(this.map);
				const lngLat = {
					lng: lng,
					lat: lat
				};
				await this.markerCommonFunction(marker1,lngLat,30);
			}
			},
			// ADD DATASETS
			async datasetsAdd() {
				let datasetName = this.user.First.charAt(0)+''+this.user.Last.charAt(0)+'_'+this.user.Uid+'_Dataset';
				const data = {
					name: datasetName,
					description: 'Dataset Description of '+datasetName
				};
				let a = await axios.post(""+this.mapboxURL+"datasets/v1/"+this.mapboxUsername+"?access_token="+this.secretToken+"&_="+Date.now()+"", data)
				.then(response => {
					//eslint-disable-next-line
					//console.log('datasetsAdd:', response);
					return response.data.id;
				});
				return a;
			},
			// RETRIEVE DATASET 
			async datasetsRetrieve(DataesetID) {
				let as = await axios.get(""+this.mapboxURL+"datasets/v1/"+this.mapboxUsername+"/"+DataesetID+"?access_token="+this.secretToken+"&_="+Date.now()+"")
				.then(response => {
					return response;
				}).catch((error) => {
					//eslint-disable-next-line
					//console.log('datasetsRetrieve Catch', error.response.status);	
					return error.response.status;
				});
				return as;
			},
			// ADD FEATURES IN DATASETS
			async datasetsFeatureAdd(dID, resp) {
				await axios.put(""+this.mapboxURL+"datasets/v1/"+this.mapboxUsername+"/"+dID+"/features/"+resp.id+"?access_token="+this.secretToken+"&_="+Date.now()+"", resp)
				.then(response => {
					//eslint-disable-next-line
					console.log('datasetsFeatureAdd then:', response);	
				}).catch(err => 
					//eslint-disable-next-line
					console.log('datasetsFeatureAdd catch:', err.response)
				);
			},
			// DELETE FEATURES IN DATASETS
			async datasetsFeatureDelete(dID, markid) {
				await axios.delete(""+this.mapboxURL+"datasets/v1/"+this.mapboxUsername+"/"+dID+"/features/"+markid+"?access_token="+this.secretToken+"&_="+Date.now()+"")
				.then(response => {
					//eslint-disable-next-line
					console.log('datasetsFeatureDelete then:', response);	
				}).catch(err => 
					//eslint-disable-next-line
					console.log('datasetsFeatureDelete catch:', err)
				);
			},
			// RETIREIVE FEATURES IN DATASETS 
			async datasetsFeatureRetrive(dbDataesetID) {
				await axios.get(""+this.mapboxURL+"datasets/v1/"+this.mapboxUsername+"/"+dbDataesetID+"/features?access_token="+this.secretToken+"&_="+Date.now()+"")
				.then(response => {
					response.data.features.forEach(f => {
						const marker1 = new this.mapbox.Marker({
							anchor: "center", 
							color: "#314ccd", 
							draggable: true
						})
						.setLngLat([f.properties.lng, f.properties.lat])
						.addTo(this.map);

						let passlng = f.properties.lng;
						let passlat = f.properties.lat;

						let u = f.id;
						let v = u.replace('mID', '');
						
						this.temp = this.temp + 1;
						var newtemp = this.temp;
						
						marker1._element.id = "mID"+v;
						marker1._element.SourceLayer = [];
						marker1._element.commuteTime = f.properties.commuteTime;

						this.markerInnerCommonFunction(passlng, passlat, newtemp, marker1, f.properties.commuteTime);

					});
					
				}).catch(err => 
					//eslint-disable-next-line
					console.log('datasetsFeatureRetrive catch:', err.response)
				);
			},

			// ADD TILESETS
			async tilesetsAdd(resp) {
				//eslint-disable-next-line
				console.log('resprespresprespresp', resp);
				let makeLayerName = resp+'_layer'; // 123_layer
				let a = {
					"recipe": {
						"version": 1,
						"layers": {
						[makeLayerName]: { 
							"source": "mapbox://tileset-source/"+this.mapboxUsername+"/"+resp+"",
							"minzoom": 0,
							"maxzoom": 5
						}
						}
					},
					"name": resp,
					"description": "Spaceship Earth with all of the people, places, and things.",
					"attribution": [
						{ "text": "© Hello Legal World", "link": "https://docs.mapbox.com" }
					]
				}
				await axios.post(""+this.mapboxURL+"tilesets/v1/"+this.mapboxUsername+"."+resp+"?access_token="+this.secretToken+"", a)
					.then(response => {
						this.tilesetsPublish(resp);
						//eslint-disable-next-line
						console.log('tilesetsAdd then:', response);	
					}).catch(err => 
						//eslint-disable-next-line
						console.log('tilesetsAdd catch:', err)
					);
			},
			// PUBLISH TILESETS
			async tilesetsPublish(resp) {
				await axios.post(""+this.mapboxURL+"tilesets/v1/"+this.mapboxUsername+"."+resp+"/publish?access_token="+this.secretToken+"")
					.then(response => {
						//eslint-disable-next-line
						console.log('tilesetsPublish then:', response);
						db.doc(`Users/${this.user.id}`).update({TilesetID:resp});
						let jobid = response.data.jobId;
						localStorage.setItem("mapboxJobID", jobid);
						//eslint-disable-next-line
						console.log('Publish jobid:', jobid);
						// this.publishStatus = true;

						this.intervalTime = setInterval(() => {
								this.tilesetsPublishStatus(resp, jobid);
								if(this.handlePublishStatus == 'success') {
									clearInterval(this.intervalTime);
									this.disabledSaveMap = false;
									localStorage.setItem("mapboxJobID", '');
									this.customPrintMsg = 'Map has been saved';
								}
						}, 5000);

						//this.tilesetsPublishStatus(resp, jobid);
					}).catch(err => 
						//eslint-disable-next-line
						console.log('tilesetsPublish catch:', err)
					);
			},
			// PUBLISH TILESETS USING JOBID
			async tilesetsPublishStatus(resp, jobid) {
				await axios.get(""+this.mapboxURL+"tilesets/v1/"+this.mapboxUsername+"."+resp+"/jobs/"+jobid+"?access_token="+this.secretToken+"")
					.then(response => {
						this.handlePublishStatus = response.data.stage;
						// if(response.stage == 'success') {
						// 	this.publishStatus = false;
						// }
						//eslint-disable-next-line
						// console.log('tilesetsPublishStatus then response.stage:', response.stage);
					}).catch(err => 
						//eslint-disable-next-line
						console.log('tilesetsPublishStatus catch:', err)
					);
			},
			// DELETE TILESETS 
			async tilesetsDelete(resp) {
				await axios.delete(""+this.mapboxURL+"tilesets/v1/"+this.mapboxUsername+"."+resp+"?access_token="+this.secretToken+"&_=1657606503331")
				.then(response => {
					// this.tilesetsSource(resp);
					//eslint-disable-next-line
					console.log('tilesetsDelete then:', response);	
				}).catch(err => 
					//eslint-disable-next-line
					console.log('tilesetsDelete catch:', err.response.data)
				);
			},
			// ADD TILESET SOURCES
			async tilesetsSource(getTileFromDB) {
				//eslint-disable-next-line
				console.log('aaa', getTileFromDB);
				let randm;
				if(getTileFromDB != '') {
					randm = getTileFromDB;
				} else {
					randm = 'Tileset'+Math.floor(Math.random()*90000) + 10000;
				}

				let passData1 = {
					userID: this.user.Uid
				};
				await axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/getFirebaseData", passData1)
				.then(resp => {
					//eslint-disable-next-line
					console.log('testFilejson Then', resp.data);

					let aa1 = JSON.stringify(resp.data);
					const jsonObject1 = JSON.parse(aa1);
					const ndJson1 = jsonObject1.map(JSON.stringify).join('\n');

					//eslint-disable-next-line
					console.log('ndJson1', ndJson1);

					const blob = new Blob([ndJson1], {
						type: 'application/json'
					});
					const data = new FormData();
					data.append("file", blob);
					axios({
						method: 'post',
						url: ''+this.mapboxURL+'tilesets/v1/sources/'+this.mapboxUsername+'/'+randm+'?access_token='+this.secretToken+'',
						data: data,
					}).then(response => {
						if(getTileFromDB == '') {
							this.tilesetsAdd(randm);
						} else {
							this.tilesetsDelete(randm);
							setTimeout(() => {
								this.tilesetsAdd(randm);
							}, 1000);
						}
						//eslint-disable-next-line
						console.log('tilesetsSource then:', response);	
					}).catch(err => 
						//eslint-disable-next-line
						console.log('tilesetsSource catch:', err)
					);
				});
				//eslint-disable-next-line
				// console.log('testFilejson', testFilejson);
			},
			// DELETE TILESET SOURCES 
			async tilesetsSourceDelete(resp) {
				await axios.delete(""+this.mapboxURL+"tilesets/v1/sources/"+this.mapboxUsername+"/"+resp+"?access_token="+this.secretToken+"&_="+Date.now()+"")
				.then(response => {
					if(response.status == 204) {
						//eslint-disable-next-line
						console.log('tilesetsSourceDelete IF', response.status);	
							// ADD ON SAME ID
							this.tilesetsSource(resp);
					}

					// this.tilesetsSource(resp);
					//eslint-disable-next-line
					console.log('tilesetsSourceDelete then:', response);	
				}).catch(err => {
					//eslint-disable-next-line
					console.log('tilesetsSourceDelete catch:', err.response.data);
					alert(err.response.data.message);
				});
			},

			// UPDATE OUT OF AREA AUTOMATED TEXT
			automatedTextUpdate() {
				db.doc(`Users/${this.user.id}`).update({areaAutomatedText:this.form.areaAutomatedText});
			},
			loadMap() {
				this.bindMap();
			},
			bindMap() {
				const defaultCoordinates = [-98.23552002615263, 40.05621444480775];
				if(this.coordinates.length > 0){
					this.coordinates = this.coordinates;
				}else{
					this.coordinates = defaultCoordinates;
				}
				this.map = new this.mapbox.Map({
					container: 'map', // container id
					style: 'mapbox://styles/mapbox/streets-v11', // stylesheet
					center: this.coordinates, // starting position [lng, lat]
					zoom: 11.5, // starting zoom
					NavigationControl: true,
				});
				this.map.addControl(new this.mapbox.NavigationControl(), 'top-right');

				var scale = new this.mapbox.ScaleControl({
					maxWidth: 200,
					unit: 'imperial'
				});
				this.map.addControl(scale, 'bottom-right');
				scale.setUnit('imperial');

				this.map.on('load', () => {	
					if(this.user.hasOwnProperty('DataesetID') && this.user.DataesetID != '') {
						this.datasetsFeatureRetrive(this.user.DataesetID);
					} else {
						
						if(this.user.hasOwnProperty('Offices') && this.user.Offices && this.user.Offices.length > 100) {
							this.AddOfficeMarkerProcess();
						} else {
							this.checkPrimaryLocation();
						}

						// if(this.user.PrimaryLocation.ZipCode) {
						// 	axios.get("https://app.zipcodebase.com/api/v1/search?apikey=cdbfa120-2941-11ef-825e-45214465aa92&codes="+this.user.PrimaryLocation.ZipCode+"&country=us")
						// 	.then(response => {
						// 		let latt = response.data.results[this.user.PrimaryLocation.ZipCode][0].latitude;
						// 		let lngg = response.data.results[this.user.PrimaryLocation.ZipCode][0].longitude;
						// 		this.AddNewMarkerWithZipCodeProcess(lngg, latt);
						// 	});
						// }
						// this.checkPrimaryLocation();
					}
				});
			},
			async checkPrimaryLocation() {
				this.mapbox.accessToken  = this.accessToken;
				if(this.user.PrimaryLocation.ZipCode) {
					await axios.get("https://app.zipcodebase.com/api/v1/search?apikey=cdbfa120-2941-11ef-825e-45214465aa92&codes="+this.user.PrimaryLocation.ZipCode+"&country=us")
					.then(response => {
						let latt = response.data.results[this.user.PrimaryLocation.ZipCode][0].latitude;
						let lngg = response.data.results[this.user.PrimaryLocation.ZipCode][0].longitude;
						this.coordinates = [lngg,latt];
						if(latt && lngg) { this.AddNewMarkerWithZipCodeProcess(lngg, latt); }
					});
				} else {
					// UNITED STATE CENTER
					let a = '40.05621444480775'; // latt
					let b = '-98.23552002615263'; // lngg
					this.coordinates = [b,a];
				}
				/*setTimeout(() => {
					this.loadMap();
					//eslint-disable-next-line
					console.log('coordinates:', this.coordinates);
				}, 2000);*/
			},
			// ADD NEW MARKER PROCESS
			AddNewMarkerProcess() {

				const centerLatLng = this.map.getCenter();

				const marker1 = new this.mapbox.Marker({
					anchor: "center", 
					color: "#314ccd", 
					draggable: true
				})
				.setLngLat([centerLatLng.lng, centerLatLng.lat])
				.addTo(this.map);

				const lngLat = {
					lng: centerLatLng.lng,
					lat: centerLatLng.lat
				};

				this.markerCommonFunction(marker1,lngLat,this.minutes);

			},
			// ADD NEW MARKER WITH ZIPCODE PROCESS
			AddNewMarkerWithZipCodeProcess(lngg, latt) {
				const marker1 = new this.mapbox.Marker({
					anchor: "center", 
					color: "#314ccd", 
					draggable: true
				})
				.setLngLat([lngg, latt])
				.addTo(this.map);

				const lngLat = {
					lng: lngg,
					lat: latt
				};

				this.markerCommonFunction(marker1,lngLat,this.minutes);
			},
			// MARKER COMMON FUNCTION
			markerCommonFunction(marker1,lngLat,setCommuttime) {
				let passlng = lngLat.lng;
				let passlat = lngLat.lat;

				this.temp = this.temp + 1;
				var newtemp = this.temp;

				marker1._element.id = "mID"+newtemp;
				marker1._element.SourceLayer = [];
				marker1._element.commuteTime = setCommuttime;

				this.markerInnerCommonFunction(passlng, passlat, newtemp, marker1, setCommuttime);
			},
			rechecktheTilesetStatus() {
				if(localStorage.getItem("mapboxJobID")) {
					this.intervalTime = setInterval(() => {
						this.tilesetsPublishStatus(this.user.TilesetID, localStorage.getItem("mapboxJobID"));
						if(this.handlePublishStatus == 'processing') {
							this.disabledSaveMap = true;
							this.tilesetStatusPublishing = true;
							this.customPrintMsg = 'Map is saving and will be ready in a couple minutes. You may leave this page';
						}
						if(this.handlePublishStatus == 'success') {
							clearInterval(this.intervalTime);
							this.disabledSaveMap = false;
							localStorage.setItem("mapboxJobID", '');
							this.customPrintMsg = 'Map has been saved';
						}
					}, 2000);
				}
			},
			// MARKER INNER COMMON FUNCTION
			markerInnerCommonFunction(passlng, passlat, newtemp, marker1, setCommuttime) {
				
				// CREATE SOURCE AND LAYER DYNAMIC
				this.loadSourceLayer(newtemp);

				// API CALL
				this.getIso(passlng, passlat, newtemp, marker1, setCommuttime);
				
				// MARKER DRAG EVENT
				marker1.on('dragend', this.bindDragMap);

				// MARKER ON CLICK EVENT
				marker1.getElement().addEventListener('click', () => {
					this.tempStoreCommuteTime = marker1._element.commuteTime;
					this.selecteCommuteTime = this.tempStoreCommuteTime;
					var x = document.getElementById("temp11");
					if(x) { x.style.display = 'block'; }
					this.tempMarkerStore = [];
					marker1.setPopup(new this.mapbox.Popup({offset: 25}).setDOMContent(this.$refs.htmlPopup));
					this.tempMarkerStore.push(marker1);
				});
			},
			// DROPDOWN CHANGE EVENT
			dropdownChangeEvent(commuteTime) {
				this.loaderIf = true;
				this.tempMarkerStore[0]._popup.remove();
				this.tempStoreCommuteTime = commuteTime;

				const newlngLat = this.tempMarkerStore[0]._lngLat;
				
				let passlng = newlngLat.lng;
				let passlat = newlngLat.lat;

				this.temp = this.temp + 1;
				var newtemp = this.temp;

				this.FeatureCollectionList.splice(this.FeatureCollectionList.indexOf(this.tempMarkerStore[0]._element.id),1);

				this.loadSourceLayer(newtemp);
				this.getIso(passlng, passlat, newtemp, this.tempMarkerStore[0], commuteTime);

				this.tempMarkerStore[0]._element.commuteTime = commuteTime;
			},
			// CREATE SOURCR AND LAYER DYNAMIC
			loadSourceLayer(temp1) {
				// WHEN THE MAP LOADS, ADD THE SOURCE AND LAYER
				this.map.addSource('iso'+temp1, {
					type: 'geojson',
					data: {
					'type': 'FeatureCollection',
					'features': []
					}
				});
			
				this.map.addLayer({
					'id': 'isoLayer'+temp1,
					'type': 'fill',
					'source': 'iso'+temp1,
					'layout': {},
					'paint': {
						'fill-color': '#5a3fc0',
						'fill-opacity': 0.3
					}
				}, 'poi-label');
			},
			// DELETE PINS (MARKERS + PPOLYGON)
			deletePin() {

				//eslint-disable-next-line
				//console.log('before', this.FeatureCollectionList);

				//eslint-disable-next-line
				// console.log('r._element.id', r._element.id);

				this.tempMarkerStore.forEach(r => {
					//eslint-disable-next-line
					//console.log('r', r);
					let rr = r._element.SourceLayer;
					let v = rr[0].replace('iso', '');
					this.map.removeLayer('isoLayer'+v);
					this.map.removeSource('iso'+v);
					r._popup.remove();

					if(this.user.hasOwnProperty('DataesetID') && this.user.DataesetID != '') {
						this.datasetsFeatureDelete(this.user.DataesetID, r._element.id);
						this.FeatureCollectionList.splice(this.FeatureCollectionList.indexOf(r._element.id),1);
					}

					let w = r._map._markers.find(uo1 => uo1._element.SourceLayer == rr[0]);
					if(w){
						w.remove();
					}
				});
				
			},
			// DRAG FUNCTION
			bindDragMap(event) {

				this.loaderIf = true;
				const newlngLat = event.target.getLngLat();
				
				let passlng = newlngLat.lng;
				let passlat = newlngLat.lat;

				this.temp = this.temp + 1;
				var newtemp = this.temp;

				// this.localMarkerProcess(event.target._element.id);

				this.FeatureCollectionList.forEach(dsn=>{
					if(dsn.id == event.target._element.id) {
						//eslint-disable-next-line
						// console.log('dsn.id',dsn.id);
						//eslint-disable-next-line
						// console.log('event.target._element.id ssss',event.target._element.id);
						this.FeatureCollectionList.splice(this.FeatureCollectionList.indexOf(dsn),1);
					}
				});

				//eslint-disable-next-line
				// console.log('this.FeatureCollectionList AFTER',this.FeatureCollectionList);

				this.loadSourceLayer(newtemp);
				this.getIso(passlng, passlat, newtemp, event.target, event.target._element.commuteTime);
			},
			featureAddProcess(DataesetID) {
				//eslint-disable-next-line
				console.log('featureAddProcess', this.FeatureCollectionList);
				this.FeatureCollectionList.forEach(r1 => {
					this.datasetsFeatureAdd(DataesetID, r1);
				});
			},
			async firebaseFileCheck() {

				
				// db.doc(`Users/${this.user.id}`).update({TilesetID:''});
				// db.doc(`Users/${this.user.id}`).update({DataesetID:''});

				/*let passData1 = {
					userID: this.user.Uid
				};
				await axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/getFirebaseData", passData1)
				.then(resp => {
					//eslint-disable-next-line
					console.log('api resprespresp', resp.data);

					let aa1 = JSON.stringify(resp.data);
					const jsonObject1 = JSON.parse(aa1);
					const ndJson1 = jsonObject1.map(JSON.stringify).join('\n');

					//eslint-disable-next-line
					console.log('api ndJson1', ndJson1);

				});*/

				/*let passData = {
					localArray: this.FeatureCollectionList,
					userID: this.user.Uid
				};
				//eslint-disable-next-line
				console.log('passData', passData);
				
				await axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/fileWriteOutOfArea", passData)
				// await axios.post("http://localhost:5000/tatext-thirdpool-development/us-central1/tatext/fileWriteOutOfArea", passData)
				.then(response => {
					//eslint-disable-next-line
					console.log('api response', response);
				}).catch(err => {
					//eslint-disable-next-line
					console.log('err response', err);
				});
				*/
				
				

				// return await fetch(
				// 'http://localhost:5000/tatext-thirdpool-development/us-central1/tatext/fileWriteOutOfArea',
				// {   method: 'POST',
				// 	mode: 'no-cors',
				// 	headers: new Headers(
				// 	{"Content-Type": "application/json",
				// 		"Access-Control-Allow-Origin":"*"}
				// 	),
				// 	body: JSON.stringify(passData)
				// }
				// ).then( response => { //eslint-disable-next-line
				// 	console.log(response);
				// }).catch(err => //eslint-disable-next-line 
				// 	console.log(err))
				
				/*
				// WORKABLE CODE
				const testFilejson1 = import(`../../../../public/outofarea/1234566.json`);
				var blob = new Blob([testFilejson1], { type: "application/json" });
				// create a reference to the storage
				// var storageRef = fbstore.ref();
				// Create a reference to the file you are about to create
				// the reference points to "/BUCKET_NAME/FILE_NAME.json"
				const fileRef = fbstore.ref('OutOfArea/123456');
				// var fileRef = fbstore.ref("/files/123456.json"); // storageRef.child("/files/123456.json"); // fbstore.ref("/files/123456.json");
				//eslint-disable-next-line
				console.log('fileRef', fileRef)
				// upload you blob into the storage 
				fileRef.put(blob).then(function(snapshot) {
					//eslint-disable-next-line
					console.log('Uploaded a blob!', snapshot);
				});
				*/
				
			},
			async SaveTilesetProcess() {
				this.disabledSaveMap = true;
				this.tilesetStatusPublishing = true;
				this.handlePublishStatus = 'processing';
				this.customPrintMsg = 'Map is saving and will be ready in a couple minutes. You may leave this page';
				// this.datasetStatus = true;

				// alert('Successfully Saved');

				//eslint-disable-next-line
				//console.log('this.FeatureCollectionList', this.FeatureCollectionList);
				
				let DataesetID;
				if(this.user.hasOwnProperty('DataesetID') && this.user.DataesetID != '') {
					DataesetID = this.user.DataesetID;
					let de = await this.datasetsRetrieve(DataesetID);
					if(de == 422) {
						DataesetID = await this.datasetsAdd();
						db.doc(`Users/${this.user.id}`).update({DataesetID:DataesetID});
					} else {
						DataesetID = this.user.DataesetID;
					}
					//eslint-disable-next-line
					//console.log('de', de);
					//eslint-disable-next-line
					//console.log('DataesetID IF', DataesetID);
					await this.featureAddProcess(DataesetID);
				} else {
					DataesetID = await this.datasetsAdd(); // ADD NEW DATASET
					db.doc(`Users/${this.user.id}`).update({DataesetID:DataesetID});
					//eslint-disable-next-line
					//console.log('DataesetID ELSE', DataesetID);
					await this.featureAddProcess(DataesetID);
				}

				//eslint-disable-next-line
				console.log('this.FeatureCollectionList', this.FeatureCollectionList);

				// // STORE DATA IN ARRAY JSON FORMAT
				// localStorage.removeItem("FeatureCollectionList");
				// localStorage.setItem("FeatureCollectionList", JSON.stringify(this.FeatureCollectionList));
				// // localStorage.setItem("dataSources", this.FeatureCollectionList);
				// let ndJson = JSON.parse(localStorage.getItem("FeatureCollectionList"));
				// //eslint-disable-next-line
				// console.log('Local FeatureCollectionList:', ndJson);

				let passData = {
					localArray: this.FeatureCollectionList,
					userID: this.user.Uid
				};
				//eslint-disable-next-line
				console.log('passData', passData);
				
				await axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/fileWriteOutOfArea", passData)
				// await axios.post("http://localhost:5000/tatext-thirdpool-development/us-central1/tatext/fileWriteOutOfArea", passData)
				.then(response => {
					//eslint-disable-next-line
					console.log('api response', response);
				}).catch(err => {
					//eslint-disable-next-line
					console.log('err response', err);
				});


				
				// FILE WRITE PROCESS
				// let passData = {
				// 	// localArray: YourItem
				// 	localArray: JSON.stringify(this.FeatureCollectionList)
				// };
				// //this.onUpload(passData);
				// axios.post("http://localhost:5000/tatext-thirdpool-development/us-central1/tatext/fileWriteOutOfArea", passData)
				// .then(response => {
				// 	//eslint-disable-next-line
				// 	console.log('api response', response);
				// });

				
				
				// let dataSetsCount = await this.datasetsList();
				//eslint-disable-next-line
				console.log('this.user.TilesetID', this.user.TilesetID);

				if(this.user.hasOwnProperty('TilesetID') && this.user.TilesetID != '') {
					let getTileFromDB = this.user.TilesetID; 
					await axios.get(""+this.mapboxURL+"tilesets/v1/sources/"+this.mapboxUsername+"/"+getTileFromDB+"?access_token="+this.secretToken+"&_="+Date.now()+"")
					.then(response => {
						if(response.status == 200) {
							//eslint-disable-next-line
							console.log('dataSourceRetrieve SUCCESS1', response.status);	
							// DELETE OLD ONE
							this.tilesetsSourceDelete(getTileFromDB);
							// setTimeout(() => {
								// ADD ON SAME ID
								// this.tilesetsSource(getTileFromDB);
							// }, 3000);
						}

					}).catch(err => {
						if(err.response.data.message) {
							//eslint-disable-next-line
							// console.log('dataSourceRetrieve ERROR1', err.response.data.message);
							this.mapboxPanelHitAPIs();
						}
					});
				} else {
					this.mapboxPanelHitAPIs();
				}

				

			},
			// LOCAL STORAGE MARKER PROCESS
			// localMarkerProcess(aid) {
			// 	this.FeatureCollectionList.forEach(dsn=>{
			// 		if(dsn.id == aid) {
			// 			this.FeatureCollectionList.splice(this.FeatureCollectionList.indexOf(dsn),1);
			// 		}
			// 	});
			// },
			onUpload(passData){
				// const ref = fbstore.ref().child('Template/'+this.Subject+'.html').putString(this.Message);
				const storageRef = fbstore.ref('outofarea/'+this.user.Uid).put(passData);
				//eslint-disable-next-line
				console.log('storageRef', storageRef);
				storageRef.on(`state_changed`,snapshot=>{
					this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
				}, error=>{
					//eslint-disable-next-line
					console.log(error.message)
				},
				()=>{this.uploadValue=100;
					storageRef.snapshot.ref.getDownloadURL().then((url)=>{	
						this.uploadedURL = url;
						this.attachmentArray.push({
							'content':this.filePath,
							'filename':this.fileName,
							'type':this.fileType,
							'content_id':this.fileName,
							// 'storedFilePath':this.uploadedURL
						});
						// this.filesArray.push({'name':this.fileName,'path':this.uploadedURL});
					});
				});
			},
			mapboxPanelHitAPIs() {
				// this.dataSourceArray.forEach(d => {
				// 	//eslint-disable-next-line
				// 	console.log('d', d);
				// 	// this.datasetsAdd(d);
				// });
				let tilesetSourceID = '';
				this.tilesetsSource(tilesetSourceID);
			},
			// API
			async getIso(passlng, passlat, isopass, marker, commuteTime) {
				await axios.get("https://api.mapbox.com/isochrone/v1/mapbox/"+this.profile+"/"+passlng+","+passlat+"?contours_minutes="+commuteTime+"&polygons=true&denoise=0.5&generalize=185&access_token="+this.accessToken+"")
				.then(response => {
					
					//eslint-disable-next-line
					//console.log('response:', response);
					//eslint-disable-next-line
					//console.log('response.data.features:', response.data.features[0]);

					// this.datasetsAdd();

					if (!response.data.features || response.data.features.length === 0) {
						//eslint-disable-next-line
						console.log('No features returned from the isochrone API for', { passlng, passlat });
						return; // Exit the function early
					}

					
					//this.datasetsFeatureAdd(response.data.features); // WORKABLE
					//this.tilesetsSource();
					//this.tilesetSourceList();
					// this.tilesetsAdd(9);
					
					
					var check = marker._element.SourceLayer.includes('iso'+isopass);
					if(!check) {
						marker._element.SourceLayer.push('iso'+isopass);
					}

					this.loaderIf = false;
					this.mappingData(response);
					this.map.getSource('iso'+isopass).setData(response.data);

					//eslint-disable-next-line
					console.log('getSourcePrint:', this.map.getSource('iso'+isopass));

					if(marker._element.SourceLayer.length > 0) {
						marker._element.SourceLayer.forEach(u=> {
							let v = u.replace('iso', '');
							if(isopass != v) {
								this.map.removeLayer('isoLayer'+v);
								this.map.removeSource('iso'+v);
								marker._element.SourceLayer.splice(marker._element.SourceLayer.indexOf('iso'+v), 1);
							}
						});
					}

					//eslint-disable-next-line
					//console.log('response.data.featuresresponse.data.features:', response.data.features);

					response.data.features[0]['id'] = marker._element.id;
					response.data.features[0].properties['commuteTime'] = marker._element.commuteTime;
					response.data.features[0].properties['lat'] = marker._lngLat.lat;
					response.data.features[0].properties['lng'] = marker._lngLat.lng; 
					this.FeatureCollectionList.push(response.data.features[0]);
					
					

				});
			},
			mappingData(response) {
				//eslint-disable-next-line
				//console.log('Drag Fire', this.storeLatLng);
				if(response.data.features[0].hasOwnProperty('geometry')) {
					var collectLatLng = response.data.features[0].geometry.coordinates[0];
					for(var i=0; i<collectLatLng.length; i++) {
						//eslint-disable-next-line
						// console.log('latlng', collectLatLng[i]);

						// let getlng = collectLatLng[i][0];
						// let getlat = collectLatLng[i][1];

						//eslint-disable-next-line
						//console.log('getlng', getlng);
						//eslint-disable-next-line
						//console.log('getlat', getlat);

						/*this.storeLatLng.forEach(w => {
							if(w.lng == getlng && w.lat == getlat) {
								new this.mapbox.Marker({anchor: "center", color: "gray"})
								.setLngLat([getlng, getlat])
								.addTo(this.map);
							}
						});*/

						/*let a = this.storeLatLng.find(uo1 => uo1.lat == getlat && uo1.lng == getlng);
						if(a) {
							new this.mapbox.Marker({anchor: "center", color: "gray"})
							.setLngLat([getlng, getlat])
							.addTo(this.map);
						}*/

						// REMOVE OLD MARKER
						/*this.mapMarkers.forEach((m) => m.remove())
						this.mapMarkers = [];
						
						// ADD NEW MARKER BASED ON DRAG 
						setTimeout(() => {
							const markerAdd = new this.mapbox.Marker({anchor: "center", color: "gray"})
							.setLngLat([getlng, getlat])
							.addTo(this.map);
							this.mapMarkers.push(markerAdd)
						}, 500);
						*/
						

					}
				}
			},
			postallatlng() {
				let t1 = [];
				this.prospects.forEach(p => {
					if(p.Zip) {
						var check = t1.includes(p.Zip);
						if(!check) {
							t1.push(p.Zip);
						}
					}
				});
				//eslint-disable-next-line
				//console.log('t1', t1);
				t1.forEach(r => {
					this.postalCodeAPI(r);
				});
			},
			async postalCodeAPI(p) {
				await axios.get("https://maps.googleapis.com/maps/api/geocode/json?address="+p+"&key=AIzaSyDB3iBxxzF9leRLy4mihVjBCAwWFenuuuA")
				.then(response => {
					//eslint-disable-next-line
					//console.log('responseresponse', response);
					if(response.status == 200 && response.hasOwnProperty('data') && Object.keys(response.data.results).length) {
						let results = response.data.results;
						let isFound = 0;
						for (let i = 0; i < results.length; i++) {
							for (let j = 0; j < results[i].address_components.length; j++) {
								if (results[i].address_components[j].types[0]=='country') {
									if (results[i].address_components[j].short_name == 'US') {
										isFound = 1;
										this.googlelat = response.data.results[i].geometry.location.lat;
										this.googlelng = response.data.results[i].geometry.location.lng;
										break;
									} else if (results[i].address_components[j].short_name == 'CA') {
										isFound = 2;
										this.googlelat = response.data.results[i].geometry.location.lat;
										this.googlelng = response.data.results[i].geometry.location.lng;
										break;
									}
								}
							}
						}
						if(isFound == 0) {
							this.googlelat = response.data.results[0].geometry.location.lat;
							this.googlelng = response.data.results[0].geometry.location.lng;
						}
						// STORE LAT, LNG IN ARRAY
						this.storeLatLng.push({
							lat: this.googlelat,
							lng: this.googlelng
						});
					}
				});
				
				//eslint-disable-next-line
				// console.log('storeLatLng......', this.storeLatLng);

				if(this.storeLatLng) {
					this.storeLatLng.forEach(s => {
						new this.mapbox.Marker({anchor: "center", color: "pink"})
						.setLngLat([s.lng, s.lat])
						.addTo(this.map);
					});
				}
			}

		},
		data() {
			let userData = this.$store.state.firebase.user;
			return {
				intervalTime: '',
				tempStoreCommuteTime: '',
				selecteCommuteTime: this.tempStoreCommuteTime ? this.tempStoreCommuteTime : 10,
				optionsCommuteTime: [
					{ value: '10', text: '10 Min' },
					{ value: '20', text: '20 Min' },
					{ value: '30', text: '30 Min' },
					{ value: '40', text: '40 Min' },
					{ value: '50', text: '50 Min' },
					{ value: '60', text: '60 Min' }
				],
				// mapMarkers: [],
				storeLatLng:[],
				accessToken: 'pk.eyJ1IjoibG9nYW5keml1ayIsImEiOiJja3BkZDJwNmcwMGgzMm5sZW5zemRhNjJlIn0.ulgQW-9KuvSNHB5IsW3IjQ',
				secretToken: 'sk.eyJ1IjoibG9nYW5keml1ayIsImEiOiJjbDViZnJ1aWMwNzdoM2lwZXkyZDcyMzhhIn0.tS7j7aYV8TI9iIXOi39tyg',
				// coordinates: [-118.1468148, 33.9697897],
				coordinates: [],
				mapbox: Mapbox,
				map: '',
				handlePublishStatus: '',
				customPrintMsg: '',
				// lng: -118.1468148,
				// lat: 33.9697897,
				profile: 'driving',
				minutes: 10, // SET DEFAULT DROPDOWN VALUE
				loaderIf:false,
				googlelat:'',
				googlelng:'',
				form: {
					areaAutomatedText: userData.areaAutomatedText ? userData.areaAutomatedText: '',
				},
                temp:0,
				tempMarkerStore: [],
				FeatureCollectionList: [],
				mapboxUsername: 'logandziuk',
				mapboxURL: 'https://api.mapbox.com/',
				
				datasetStatus:false,
				tilesetStatusPublishing:false,
				tilesetStatusPublished:false,
				disabledSaveMap:false,
				
			}
        }
    }
</script>

<style scoped>
.AddnewMarkerBtn1{
	color: #fff;
    padding: 7px 10px;
    border: 1px solid #042B79;
	outline: none;
    background: #042B79;
	margin-left: 3px;
}
.AddnewMarkerBtn, .AddnewMarkerBtn:hover, .AddnewMarkerBtn:focus{
	color: #fff;
    padding: 7px 10px;
    border: 1px solid #042B79;
	outline: none;
	margin-top: -140px;
    position: absolute;
    background: #042B79;
	margin-left: 3px;
}

#temp11{
	display: none;
}

.loader4 {
   width:30px;
   height:30px;
   display:inline-block;
   padding:0px;
   border-radius:100%;
   border:5px solid;
   border-top-color:#fff;
   border-bottom-color:rgba(255,255,255, 0.3);
   border-left-color:#fff;
   border-right-color:rgba(255,255,255, 0.3);
   -webkit-animation: loader4 1s ease-in-out infinite;
   animation: loader4 1s ease-in-out infinite;
}
.loader-blue .loader4{
    border-top-color:#06187c;
   border-bottom-color:rgba(255,255,255, 0.3);
   border-left-color:#06187c;display: flex;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: 0;
    bottom: 0;
   border-right-color:rgba(255,255,255, 0.3);
}
.loader-blue{
    position: absolute;
    padding-left: 0px;
    top: 0;z-index: 9999;
    margin: auto;
    bottom: 0;
}
@keyframes loader4 {
   from {transform: rotate(0deg);}
   to {transform: rotate(360deg);}
}
@-webkit-keyframes loader4 {
   from {-webkit-transform: rotate(0deg);}
   to {-webkit-transform: rotate(360deg);}
}
#map {
	height: 500px;
    width: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    position: relative;
}
.selectCheck{
	position: absolute;
    background: #fff;
    padding: 10px;
    border-radius: 3px;
    text-align: center;
	width: 220px;
}
.page-wrapper{
	height: 100vh;
	overflow-x: hidden;
	overflow-y: auto;
}
.selectCheck label{
	margin-right: 10px;
}

.fieldManage{
	width:100%;
}
.fieldManage label{
	font-weight: bold;
}

.info-box {
  position: absolute;
  margin: 20px;
  width: 25%;
  top: 0;
  bottom: 20px;
  padding: 20px;
  background-color: #fff;
  overflow-y: scroll;
  height:65%;
}

.savedStatus{
	float: right;
	margin-right:5px;
	width: 30%;
}
.savempbtn{
	position:absolute;
	margin-top:-60px;
}

</style>